import http, { API_CORE } from '../../http';

export default function OrderServiceV2() {
  const getOrders = async (params = {}) => {
    const response = await http(API_CORE).get('/v2/orders', { params });
    return response.data;
  };

  const getOrderById = async (id) => {
    const response = await http(API_CORE).get(`/v2/orders/${id}`);
    return response.data;
  };

  const createOrderShoppingCart = async (data) => {
    const response = await http(API_CORE).post('/v2/orders/shopping-cart', data);
    return response.data;
  };

  const createOrderBuyNow = async (data) => {
    const response = await http(API_CORE).post('/v2/orders/buy-now', data);
    return response.data;
  };

  const processCallback = async (data) => {
    const response = await http(API_CORE).post('/v2/orders/callback', data);
    return response.data;
  };

  const getAdminOrders = async (params = {}) => {
    const response = await http(API_CORE).get('/v2/admin/orders', { params });
    return response.data;
  };

  const getAdminOrderById = async (id) => {
    const response = await http(API_CORE).get(`/v2/admin/orders/${id}`);
    return response.data;
  };

  const confirmAdminOrder = async (id, data = {}) => {
    const response = await http(API_CORE).patch(`/v2/admin/orders/${id}/confirm`, data);
    return response.data;
  };

  const rejectAdminOrder = async (id, data = {}) => {
    const response = await http(API_CORE).patch(`/v2/admin/orders/${id}/reject`, data);
    return response.data;
  };

  const estimateDelivery = async (data) => {
    const response = await http(API_CORE).post('/v2/orders/estimate-delivery', data);
    return response.data;
  };

  return {
    getOrders,
    getOrderById,
    createOrderShoppingCart,
    createOrderBuyNow,
    processCallback,
    estimateDelivery,
    getAdminOrders,
    getAdminOrderById,
    confirmAdminOrder,
    rejectAdminOrder,
  };
}
